// extracted by mini-css-extract-plugin
export default {"full":"Bio_full__cyTnd","header":"Bio_header__oGeov","content":"Bio_content__5Uopr","textbox":"Bio_textbox__OdUQn"};